export function courseVideoHasEnded(){
    Alpine.data('video_has_ended', () => ({
        show_modal: false,

        modal: {
            ["x-show"]() {
                return this.show_modal
            },
            ["x-on:keydown.escape.prevent.stop"]() {
                this.show_modal = false
            },
        },

        overlay: {
            ["x-show"]() {
                return this.show_modal
            }
        },

        panel: {
            ["x-show"]() {
                return this.show_modal
            }
        },

    }))
}